// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".singleLayout{height:100%;width:100%;flex-direction:column;display:flex}.singleContent,.singleContentFill{width:100%;padding:50px;height:inherit;background-color:#f8f8f8}.singleContentFill{padding:0}", ""]);
// Exports
module.exports = exports;
